import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import React from "react";

export function MarkdownDisplay({
                                    value,
                                }: {
    value: string;
}) {
    return (
        <div className="prose prose-sm max-w-none">
            {/*<ReactMarkdown*/}
            {/*    remarkPlugins={[remarkGfm]}*/}
            {/*    components={{*/}
            {/*        h1: (p) => <h1*/}
            {/*            className="text-xl font-semibold text-slate-900 mt-0 mb-3" {...p} />,*/}
            {/*        h2: (p) => <h2*/}
            {/*            className="text-lg font-semibold text-slate-900 mt-6 mb-2" {...p} />,*/}
            {/*        h3: (p) => <h3*/}
            {/*            className="text-base font-semibold text-slate-900 mt-4 mb-2" {...p} />,*/}
            {/*        p: (p) => <p*/}
            {/*            className="text-sm leading-6 text-slate-800 my-2" {...p} />,*/}
            {/*        ul: (p) => <ul className="list-disc pl-5 my-2 space-y-1" {...p} />,*/}
            {/*        ol: (p) => <ol*/}
            {/*            className="list-decimal pl-5 my-2 space-y-1" {...p} />,*/}
            {/*        li: (p) => <li*/}
            {/*            className="text-sm leading-6 text-slate-800" {...p} />,*/}
            {/*        strong: (p) => <strong*/}
            {/*            className="font-semibold text-slate-900" {...p} />,*/}
            {/*        hr: () => <hr className="my-4 border-black/10"/>,*/}
            {/*    }}*/}
            {/*>*/}
            {/*    {value}*/}
            {/*</ReactMarkdown>*/}
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h1: (p) => <h3 className="mt-6 mb-2 text-base font-semibold text-slate-900" {...p} />,
                    h2: (p) => <h3 className="mt-6 mb-2 text-base font-semibold text-slate-900" {...p} />,
                    h3: (p) => <h3 className="mt-5 mb-2 text-sm font-semibold text-slate-900" {...p} />,
                    p: (p) => <p className="my-3" {...p} />,
                    ul: (p) => <ul className="my-3 list-disc pl-6 space-y-1" {...p} />,
                    ol: (p) => <ol className="my-3 list-decimal pl-6 space-y-1" {...p} />,
                    li: (p) => <li className="leading-7" {...p} />,
                    strong: (p) => <strong className="font-semibold text-slate-900" {...p} />,
                    a: (p) => (
                        <a
                            {...p}
                            className="font-medium text-orange-700 underline underline-offset-4 hover:text-orange-800"
                            target="_blank"
                            rel="noreferrer"
                        />
                    ),
                    hr: () => <hr className="my-6 border-black/10"/>,

                    // Optional: style tables
                    table: (p) => <table className="w-full border-collapse text-sm my-4" {...p} />,
                    thead: (p) => <thead className="bg-gray-100" {...p} />,
                    th: (p) => <th className="border px-3 py-2 text-left font-semibold" {...p} />,
                    td: (p) => <td className="border px-3 py-2" {...p} />,
                    tr: (p) => <tr className="hover:bg-gray-50" {...p} />,
                }}
            >
                {value}
            </ReactMarkdown>
        </div>
    );
}